import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import SliderJacketCover from '@bibliocommons/shared-slider-jacket-cover';

import { CONTENT_PROVIDER_IDS } from 'app/constants/BibConstants';
import SearchAnalyticsContext from 'app/components/search/SearchAnalyticsContext';
import { recommendationShape } from 'app/shapes/search';

import './styles/RecommendationItem.scss';

class RecommendationItem extends React.PureComponent {
  renderAvailableCount() {
    if (this.props.recommendation.availableCopies) {
      return (
        <FormattedMessage
          id="while_you_wait_available_count"
          values={{ count: this.props.recommendation.availableCopies }}
        >
          {message => <span className="available-count">{message}</span>}
        </FormattedMessage>
      );
    }

    return null;
  }

  render() {
    const { recommendation, recommendationType } = this.props;

    const { trackRecommendationClick } = this.context;

    return (
      <div className="cp-recommendation-item">
        <SliderJacketCover
          key={recommendation.id}
          item={recommendation}
          handleClick={() => trackRecommendationClick({ bib: recommendation, recommendationType })}
        />
        {this.renderAvailableCount()}
      </div>
    );
  }
}

RecommendationItem.contextType = SearchAnalyticsContext;

RecommendationItem.propTypes = {
  recommendation: recommendationShape.isRequired,
  recommendationType: PropTypes.oneOf(Object.values(CONTENT_PROVIDER_IDS)).isRequired
};

export default RecommendationItem;
